"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../../../utils/constants");
var muiInReviewBase = {
    paths: [
        {
            path: 'M11 0c6.075 0 11 4.925 11 11s-4.925 11-11 11S0 17.075 0 11 4.925 0 11 0zm0 2a9 9 0 100 18 9 9 0 000-18zm.504 2.12a1 1 0 01.36.36l5.259 9.016A1 1 0 0116.259 15H5.741a1 1 0 01-.864-1.504l5.26-9.015a1 1 0 011.367-.36zM11 12a1 1 0 100 2 1 1 0 000-2zm1-5h-2v4h2V7z',
            fill: constants_1.defaultFill,
        },
    ],
    title: 'In Review',
    width: 22,
    height: 22,
};
var muiInReview = {
    base: muiInReviewBase,
};
exports.muiInReview = muiInReview;
//# sourceMappingURL=inReview.js.map